const ToggleSwitch = ({ disabled, checked, onChangeFunction, id }) => {

    return (
        <label className="switch">
            <input 
            type="checkbox" 
            id={id || ''}
            disabled={disabled}
            checked={checked} 
            onChange={(e) => onChangeFunction(e.target.checked)} 
            />
            <span className="slider"></span>
        </label>
    );
}

export default ToggleSwitch